import { createGlobalStyle } from "styled-components";
import { getScrollbarStyle } from "../Scrollbar/Scrollbar.style.js";
import { BASELINE_CONSTANTS } from "../../constants/baseline.constants.js";

export const createGlobalStyleSheet = createGlobalStyle<{ fontSize: number; addMainBackground: boolean; mainFontColor: string }>`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  ${({ theme }) =>
      theme.customScrollbars
          ? `
  * { ${getScrollbarStyle(theme)} }
  `
          : ""}
  :root {
    font-size: ${({ fontSize }) => fontSize}px;
    ${BASELINE_CONSTANTS.REM_BASELINE_PROPERTY}: ${({ fontSize }) => fontSize}px;
  }

  html {
    height: 100%;
    color: ${({ mainFontColor }) => mainFontColor};
  }

  body {
    margin: 0;
    padding: 0;
    height: 100%;
    ${({ addMainBackground, theme }) => addMainBackground && `background: ${theme.backgrounds.interface} !important;`}
    overflow-x: hidden;
  }

  #root {
    overflow: hidden;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .popover-container {
    height: fit-content;
    width: fit-content;
  }

  ${({ theme }) =>
      Object.entries(theme.colors).map(
          ([name, colors]) => `
    .text-${name} {
      color: ${"100" in colors ? colors["100"] : undefined};
    }
  `,
      )}

  ${({ theme }) =>
      Object.entries(theme.grayscale).map(
          ([name, grayscale]) => `
    .text-${name} {
      color: ${grayscale};
    }
  `,
      )}
`;
